import { Component, OnInit, Input, Optional, Self, ChangeDetectionStrategy } from '@angular/core';
import { FieldConventionService, ValidationMessageService } from 'src/app/stp/stp-app/forms';
import { BaseInputComponent } from '../base-input';
import { NgControl } from '@angular/forms';

@Component({
  selector: 'stp-textarea',
  templateUrl: './textarea.component.html'
})
export class TextareaComponent extends BaseInputComponent implements OnInit {

  @Input() maxLength = 255;
  @Input() rows = 5;

  constructor(@Optional() @Self() ngControl: NgControl,
    fieldConventionService: FieldConventionService,
    validationMessageService: ValidationMessageService) {
    super(ngControl, fieldConventionService, validationMessageService);
  }

  ngOnInit() {
    super.ngOnInit();
  }
}
